/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiDiffInstancesListParams = zod.strictObject({
    format: zod.enum(['csv', 'json']).optional(),
    limit: zod.number().optional(),
    order: zod.string().optional(),
    page: zod.number().optional(),
});

export type ApiDiffInstancesListParams = zod.input<
    typeof ApiDiffInstancesListParams
>;
export type ApiDiffInstancesListParamsOutput = zod.output<
    typeof ApiDiffInstancesListParams
>;
